import React from 'react';
import PropTypes from 'prop-types';

export const GeneralLoading = ({
    fullScreen = false,
    background = '#373737',
    borderRadius = 16,
    width = 64,
    height = 32,

    circleRadius = 12,
    circleFill = '#ffffff',
    vboxWidth = 100,
    vboxHeight = 100,
    dotsSpacing = 48,
    animationValues = '0;1;0',
    animationDuration = 1,
    animationTimeSpacing = 0.25,
    repeatCount = 'indefinite',
    numDots = 3,
    keyTimes = '0;0.5;1'
}) => {
    const vbox = `0 0 ${vboxWidth} ${vboxHeight}`;
    const dots = new Array(numDots).fill(0);

    let wrapperStyle = {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    };
    if (fullScreen) {
        wrapperStyle = {
            ...wrapperStyle,
            position: 'fixed'
        };
    }

    return (
        <div style={wrapperStyle}>
            <svg
                style={{ background, display: 'block', borderRadius: `${borderRadius}px` }}
                viewBox={vbox}
                width={width}
                height={height}
                preserveAspectRatio="xMidYMid"
            >
                {dots.map((_, iterator, arr) => {
                    const idx = iterator - Math.floor(arr.length / 2);

                    const position = `${(vboxWidth / 2) + (dotsSpacing * idx)} ${vboxHeight / 2}`;
                    const begin = `${animationTimeSpacing * idx}s`;

                    return (
                        <g transform={`translate(${position})`} key={position}>
                            <circle cx="0" cy="0" r={circleRadius} fill={circleFill}>
                                <animateTransform
                                    attributeName="transform"
                                    type="scale"
                                    begin={begin}
                                    calcMode="spline"
                                    keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                                    values={animationValues}
                                    keyTimes={keyTimes}
                                    dur={`${animationDuration}s`}
                                    repeatCount={repeatCount}
                                />
                            </circle>
                        </g>
                    );
                })}
            </svg>
        </div>
    );
};


GeneralLoading.propTypes = {
    fullScreen: PropTypes.bool,
    background: PropTypes.string,
    borderRadius: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,

    circleRadius: PropTypes.number,
    circleFill: PropTypes.string,
    vboxWidth: PropTypes.number,
    vboxHeight: PropTypes.number,
    dotsSpacing: PropTypes.number,
    animationValues: PropTypes.string,
    animationDuration: PropTypes.number,
    animationTimeSpacing: PropTypes.number,
    repeatCount: PropTypes.string,
    numDots: PropTypes.number,
    keyTimes: PropTypes.string
};
